import React from 'react';

const ChatBubble = ({
    text,
    isOwn,
    timestamp,
    showAvatar,
    avatarUrl,
    senderInitial,
    tipLabel,
}) => {
    return (
        <div className={`bubble-row ${isOwn ? 'bubble-row-right' : 'bubble-row-left'}`}>
            {!isOwn && (
                <div className="bubble-avatar-slot">
                    {showAvatar ? (
                        avatarUrl ? (
                            <img src={avatarUrl} alt="Avatar" />
                        ) : (
                            <span>{senderInitial}</span>
                        )
                    ) : (
                        <span className="bubble-avatar-placeholder" />
                    )}
                </div>
            )}
            <div className="bubble-stack">
                <div className={`chat-bubble-ui ${isOwn ? 'mine' : 'theirs'}`}>
                    {text}
                </div>
                <div className={`bubble-meta ${isOwn ? 'meta-right' : 'meta-left'}`}>
                    <span>{timestamp}</span>
                    {tipLabel && <em>{tipLabel}</em>}
                </div>
            </div>
        </div>
    );
};

ChatBubble.defaultProps = {
    text: '',
    timestamp: '',
    showAvatar: false,
    avatarUrl: null,
    senderInitial: 'U',
    tipLabel: null,
};

export default ChatBubble;

